module.exports = __webpack_public_path__ + "img/ua_wand.1e67052f.jpg";